import { Routes, Route, Navigate, BrowserRouter } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import AppLayout from "@/components/AppLayout";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Copilot from "@/pages/Copilot";
import Incidents, { IncidentDetail } from "@/pages/Incidents";
import Knowledge from "@/pages/Knowledge";
import Documents from "@/pages/Documents";
import Analytics from "@/pages/Analytics";
import Organization from "@/pages/Organization";
import Notifications from "@/pages/Notifications";
import Settings from "@/pages/Settings";
import Connectors from "@/pages/Connectors";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/app" element={<AppLayout />}>
            <Route index element={<Navigate to="/app/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="copilot" element={<Copilot />} />
            <Route path="incidents" element={<Incidents />} />
            <Route path="incidents/:id" element={<IncidentDetail />} />
            <Route path="knowledge" element={<Knowledge />} />
            <Route path="documents" element={<Documents />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="organization" element={<Organization />} />
            <Route path="connectors" element={<Connectors />} />
            <Route path="notifications" element={<Notifications />} />
            <Route path="settings" element={<Settings />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
